import React from 'react';
import { connect } from 'react-redux';
import ChangePasswordSubscription from 'containers/ChangePasswordSubscription';
import DesktopNotificationTray from 'containers/DesktopNotificationTray';
import DrawingPrizeAlert from 'containers/DrawingPrizeAlert';
import ErrorBoundary from 'containers/ErrorBoundary';
import GraphQLErrorMessageModal from 'containers/GraphQLErrorMessageModal';
import SurveyPalModal from 'containers/SurveyPalModal';
import TermsOfServiceSubscription from 'containers/TermsOfServiceSubscription';
import WScoreWheelPopup from 'containers/WScoreWheelPopup';
import Footer from 'components/Footer';
import ForcedLocationPreference from 'components/ForcedLocationPreference';
import Header from 'components/Header';
import IntroTour from 'components/IntroTour';
import OnboardTour from 'components/OnboardTour';
import RmgRedirectPopUp from 'components/RmgRedirectPopUp';
import WhatsNewModal from 'components/WhatsNewModal';
import ThemeBackground from 'theme/ThemeBackground';
import ThemeDecorations from 'theme/ThemeDecorations';
import ThemeMusic from 'theme/ThemeMusic';
import { isAuthenticated } from 'utils/auth';
import {
  TRANSITION_PAGE_IN_SOUND,
  TRANSITION_PAGE_OUT_SOUND
} from 'utils/soundConstants';
import { playSound } from '../actions';
import DesktopWebRoutes from './DesktopWebRoutes';
import DesktopWebSounds from './DesktopWebSounds';
import './DesktopWeb.css';

function DesktopWebApp({
  location,
  onRouteTransitionStart,
  onRouteTransitionInterval
}) {
  const authenticated = isAuthenticated();

  return (
    <>
      <DesktopWebSounds />
      <ThemeMusic authenticated={authenticated} />
      <div className="main-background" aria-hidden="true">
        <ThemeBackground authenticated={authenticated} />
      </div>

      {authenticated && (
        <ErrorBoundary invisible>
          <Header pathname={location.pathname} />
        </ErrorBoundary>
      )}

      <main id="main-content">
        {authenticated && (
          <ErrorBoundary invisible>
            <ThemeDecorations />
          </ErrorBoundary>
        )}
        <DesktopWebRoutes
          authenticated={authenticated}
          location={location}
          onTransitionStart={onRouteTransitionStart}
          onTransitionInterval={onRouteTransitionInterval}
        />
      </main>

      {authenticated && (
        <>
          <ErrorBoundary invisible>
            <WScoreWheelPopup location={location} />
          </ErrorBoundary>
          <ErrorBoundary invisible>
            <WhatsNewModal />
          </ErrorBoundary>
          <ErrorBoundary invisible>
            <Footer />
          </ErrorBoundary>
          <ErrorBoundary invisible>
            <DesktopNotificationTray />
          </ErrorBoundary>
          <ErrorBoundary invisible>
            <DrawingPrizeAlert />
          </ErrorBoundary>
          <ErrorBoundary invisible>
            <IntroTour />
          </ErrorBoundary>
          <ErrorBoundary invisible>
            <OnboardTour />
          </ErrorBoundary>
          <ErrorBoundary invisible>
            <TermsOfServiceSubscription />
          </ErrorBoundary>
          <ErrorBoundary invisible>
            <ChangePasswordSubscription />
          </ErrorBoundary>
          <ErrorBoundary invisible>
            <ForcedLocationPreference />
          </ErrorBoundary>
        </>
      )}

      <ErrorBoundary invisible>
        <RmgRedirectPopUp pathname={location.pathname} />
      </ErrorBoundary>
      <ErrorBoundary invisible>
        <SurveyPalModal />
      </ErrorBoundary>
      <ErrorBoundary invisible>
        <GraphQLErrorMessageModal />
      </ErrorBoundary>
    </>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    onRouteTransitionStart: () =>
      dispatch(playSound(TRANSITION_PAGE_OUT_SOUND)),
    onRouteTransitionInterval: () =>
      dispatch(playSound(TRANSITION_PAGE_IN_SOUND))
  };
}

const withConnect = connect(null, mapDispatchToProps);

export default withConnect(DesktopWebApp);
